import { createRemoteComponent } from '@remote-ui/core';

/**
 * Buttons are used for actions, such as “Add”, “Continue”, “Pay now”, or “Save”.
 */
const Button = createRemoteComponent('Button');

export { Button };
